import { Component, OnInit } from '@angular/core';
import { EditEntityBaseClass } from '../EditEntityBaseClass'; 
import { ServiceService, Service, ServiceSummary } from '../../services/service.service';
import { ReligionBranchServiceService, ReligionBranchSummary } from '../../services/religion-branch.service';
import { ServiceTypeService, ServiceType } from '../../services/service-type.service';
import { ServiceDateType, ServiceDateTypeService } from '../../services/service-date-type.service';
import { LiturgyType, LiturgyTypeService } from '../../services/liturgy-type.service';
import { FeastType, FeastTypeService } from '../../services/feast-type.service';
import { VestmentColor, Season } from '../../../../objects';
import { VestmentColorService } from '../../services/vestment-color.service';
import { SeasonService } from '../../services/season.service';
import { LectionarySource, LectionarySourceService } from '../../services/lectionary-source.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
selector: 'app-service-edit',
  templateUrl: './service-edit.component.html',
  styleUrls: ['./service-edit.component.css']
})
export class ServiceEditComponent extends EditEntityBaseClass  implements OnInit {

  public headerTitle: string;
  public item: Service;
  public religionBranches: ReligionBranchSummary[];
  public serviceTypes: ServiceType[];
  public serviceDateTypes: ServiceDateType[];
  public liturgyTypes: LiturgyType[];
  public feastTypes: FeastType[];
  public vestmentColors: VestmentColor[];
  public lectionarySources: LectionarySource[];
  public seasons: Season[];

  public parentServiceName: string;
 
  public listsLoaded = false;

  public saveButtonText = "Save";

  constructor(
    private serviceSvc: ServiceService,
    private religionBranchSvc: ReligionBranchServiceService,
    private serviceTypeSvc: ServiceTypeService,
    private serviceDateTypeSvc: ServiceDateTypeService,
    private vestmentColorSvc: VestmentColorService,
    private liturgyTypeSvc: LiturgyTypeService,
    private feastTypeSvc: FeastTypeService,
    private seasonSvc: SeasonService,
    private lectionarySourceSvc: LectionarySourceService,
    private dialog: MatDialogRef<ServiceEditComponent>
  ) {
    super();
  }

  public LoadItem(id: string) {
    console.log("LoadItem", id);
    this.headerTitle = "Edit Service";
    var x = this.serviceSvc.getItem(id).then(
      (data) => {
        this.item = data;
 
        if (this.item.ProofedByName != "") {
          this.saveButtonText = "Save and Clear Proofing";
        }
        
        console.log("service loaded", data);
        this.GetParentService(this.item);
      }
    );
  }


  public NewItem() {
    console.log("NewItem");
    this.headerTitle = "Add Service";
    this.item = new Service();
    this.item.Id = null; 
  }

  private GetParentService(childService: Service) {

    this.parentServiceName = "";
    
    if (childService.OtherServiceId != null) {
      console.log("Getting Parent Service", childService.OtherServiceId);
      var x = this.serviceSvc.getItem(childService.OtherServiceId).then(
        (data) => { 

          if (data != null) { 
            this.parentServiceName = data.Localized[0].Name;
          }
          console.log("parent service loaded", data);
        }
      );
    }
  }

  ngOnInit() {

    this.listsLoaded = false;

    this.currentLocalizedData = null;
    if (this.item != null && this.item.Localized != null) {
      this.currentLocalizedData = this.item.Localized[0];
    }

    var religionBranchPromise = this.religionBranchSvc.loadEntities().then(
      (data) => {
        this.religionBranches = data;
      }
    );

    // var serviceTypePromise = this.serviceTypeSvc.loadEntites().then(
    //   (data) => {
    //     this.serviceTypes = data;
    //   }
    // );

    var serviceDateTypePromise = this.serviceDateTypeSvc.loadEntites().then(
      (data) => {
        this.serviceDateTypes = data;
      }
    );

// //Probably don't need this call anymore
//     var liturgyTypePromise = this.liturgyTypeSvc.loadEntites().then(
//       (data) => {
//         this.liturgyTypes = data;
//       }
//     );

    var feastTypePromise = this.feastTypeSvc.loadEntites().then(
      (data) => {
        this.feastTypes = data;
      }
    )

    var vestmentColorPromise = this.vestmentColorSvc.loadEntites().then(
      (data) => {
        this.vestmentColors = data;
      }
    )

    var seasonPromise = this.seasonSvc.loadEntites().then(
      (data) => {
        this.seasons = data;
      }
    )

    var lectionarySourcePromise = this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data;
      }
    )

    Promise.all([
        religionBranchPromise,
        // serviceTypePromise,
        serviceDateTypePromise,
       // liturgyTypePromise,
        feastTypePromise,
        seasonPromise,
        lectionarySourcePromise,
        vestmentColorPromise]).then(
      (data) => {
        console.log("All promises are completed");
        this.listsLoaded = true;
      }
    )

    console.clear();

    console.log(this.item)

  }

  public cancel() {
    this.dialog.close();
  }

  public save(isProofed: boolean) {
    console.log("SAVE", this.item);

    // if (this.item.ServiceDateType == null) {
    //   alert("Please select a Service Date Type");
    //   return;
    // }

    // if (this.item.FeastType == null) {
    //   alert("Please select a Feast Type");
    //   return;
    // }

    this.serviceSvc.save(this.item, isProofed).then(
      (data) => {
        console.log("item saved", data);
        this.dialog.close(data);
      }
    ).catch((err) => {

      if (err.status == 406) {  
        var errorReason = JSON.parse(err._body).reason; 
        alert("Invalid request: " + errorReason);
      } else {
        console.log("error", err);
      }

    })

  }

  public compareColor(color1: VestmentColor, color2: VestmentColor) {
   // console.log("Comparing colors", color1, color2);
    if (color1.Id === color2.Id) { return true };
    return false;
  }

  public serviceSuggestSelected(service: ServiceSummary) {
    console.log("serviceSuggestSelected", service); 
    this.item.OtherServiceId = service.Id;
  }

}
